import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { TranslatePipe } from "../../pipes/translate.pipe";

@Component({
  selector: "app-reusable-alert-popup",
  templateUrl: "./reusable-alert-popup.component.html",
  styleUrls: ["./reusable-alert-popup.component.scss"],
  providers: [TranslatePipe],
})
export class ReusableAlertPopupComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() titleKey: string = "";
  @Input() titleReplace: any;
  @Input() messageKey: string = "";
  @Input() messageReplace: any;
  @Input() primaryButtonLabelKey: string = "";
  @Input() secondaryButtonLabelKey: string = "";
  @Input() showPrimaryButton: boolean = true;
  @Input() showSecondaryButton: boolean = true;
  @Input() closeOnBackdrop: boolean = true;
  @Input() iconText: string = "!";

  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Output() primaryAction: EventEmitter<void> = new EventEmitter<void>();
  @Output() secondaryAction: EventEmitter<void> = new EventEmitter<void>();

  public translatedTitle: string = "";
  public translatedMessage: string = "";
  public translatedPrimaryButtonLabel: string = "";
  public translatedSecondaryButtonLabel: string = "";

  constructor(private translate: TranslatePipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.updateLabels();
    }
  }

  public onBackdropClick(event: MouseEvent): void {
    if (this.closeOnBackdrop && event.target === event.currentTarget) {
      this.handleClose();
    }
  }

  public handleClose(): void {
    this.close.emit();
  }

  public handlePrimaryAction(): void {
    this.primaryAction.emit();
  }

  public handleSecondaryAction(): void {
    this.secondaryAction.emit();
  }

  private updateLabels(): void {
    this.translatedTitle = this.getTranslatedLabel(
      this.titleKey,
      this.titleReplace,
    );
    this.translatedMessage = this.getTranslatedLabel(
      this.messageKey,
      this.messageReplace,
    );
    this.translatedPrimaryButtonLabel = this.getTranslatedLabel(
      this.primaryButtonLabelKey,
    );
    this.translatedSecondaryButtonLabel = this.getTranslatedLabel(
      this.secondaryButtonLabelKey,
    );
  }

  private getTranslatedLabel(labelKey: string, replace?: any): string {
    if (!labelKey) {
      return "";
    }
    return this.translate.transform(
      labelKey,
      "LABELS",
      undefined,
      undefined,
      replace,
    );
  }
}
